import { Component, Input, OnInit } from '@angular/core';
import { AppBaseComponent } from "@utils";
import { ControlContainer, FormBuilder } from "@angular/forms";
import { MessageService, ProcedureService,MasterService } from "@services";
import Swal from "sweetalert2";


@Component({
  selector: 'app-modification',
  templateUrl: './modification.component.html',
  styleUrls: [ './modification.component.scss' ]
})
export class ModificationComponent extends AppBaseComponent implements OnInit {

  @Input() isPersonaJuridica: boolean = false;

  textPopUpAyudaSoporteModificacion: string = "<p style='text-align: justify;' class='text-left'>Favor adjuntar como soporte de la modificación según lo seleccionado en motivo de modificación:</p>" +
    "<ul style='text-align: justify;' class='text-left'>\n" +
    "\n" +
    "<li style='text-align: justify;' class='text-left'>Cambio de Representante legal o razón social: Cámara de Comercio y CC del Representante legal.</li>\n" +
    "<li style='text-align: justify;' class='text-left'> Cambio de Dirección: Cámara de comercio donde se evidencie la nueva dirección. </li>\n" +
    "<li style='text-align: justify;' class='text-left'> Nueva sede o cierre sede: Cámara de comercio donde se evidencie las sedes con sus respectivas direcciones. </li>\n" +
    "<li style='text-align: justify;' class='text-left'> Adición o Supresión de campo: Anexo Recurso humano diligenciado. </li>\n" +
    "\n" +
    "</ul>";


  public modificationForm;//: FormGroup;
  public reasonsModification: any[] = [];
  public listFiles: any[] = [];

  constructor(public fb: FormBuilder,
              private controlContainer: ControlContainer,
              private popupService: MessageService,
              public procedureService: ProcedureService,
              private masterService: MasterService
  ) {
    super();
  }

  ngOnInit(): void {
    this.modificationForm = this.controlContainer.control;
    this.modificationForm = this.modificationForm.controls['modificationForm'];
    let personType = this.isPersonaJuridica  ? 2 : 1
    this.masterService.getReasonModification(personType).subscribe(resp => this.reasonsModification = resp)
  }

  public verificarArchivoEscogido(event: any): void {
    let archivos = event.target.files;
    if (archivos.length > 1) {
      this.popupService.errorAlert('Solo puedes cargar un archivo', 3000);
      event.target.value = '';
    }

    if (archivos.length == 1 && archivos[0].type != "application/pdf") {
      event.target.value = '';
      this.popupService.errorAlert('Formato no valido, solo se admiten documentos en formato PDF', 3000);
    }

    const file = event.target.files[0] || null;
    this.modificationForm.patchValue({
      licenciaVigenteFile: file
    });
    console.log(this.modificationForm.value)
  }

  public verificarArchivoEscogidoSoporteModificacion(event: any): void {
    let archivos = event.target.files;
    if (archivos.length > 1) {
      this.popupService.errorAlert('Solo puedes cargar un archivo', 3000);
      event.target.value = '';
    }

    if (archivos.length == 1 && archivos[0].type != "application/pdf") {
      event.target.value = '';
      this.popupService.errorAlert('Formato no valido, solo se admiten documentos en formato PDF', 3000);
    }

    const fileSoporte = event.target.files[0] || null;
    this.modificationForm.patchValue({
      soporteModificacionFile: fileSoporte
    });
    console.log(this.modificationForm.value)
  }

  public popUpAyudaSoporteModificacion(): void {
    Swal.fire({
      title: 'Ayuda',
      html: this.textPopUpAyudaSoporteModificacion,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'OK',
      showCloseButton: true
    });
  }

  getErrorMessage(field: string): string {
    let message;
    let campoObligatorio = "Es requerido";
    let fechaErronea = "La fecha no puede ser una fecha futura o superior a la de hoy";

    const onlyNumbers: Array<string> = ['resolutionToModify'];
    if(this.isTouchedField(this.modificationForm, field))
    {
      if(this.modificationForm?.get(field).hasError('invalidDate'))
      {
        message = fechaErronea;
      }
      else if(this.modificationForm?.get(field).hasError('required'))
      {
        message = campoObligatorio;
      }
      else if(this.modificationForm?.get(field).hasError('pattern') && onlyNumbers.includes(field) )
      {
        message = `Solo se admiten numeros`;
      }
    }

    return message;
  }

  verificarFecha( ){
    //Bloquea del calendario desplegable
    const datepicker = document.getElementById('fecha-resolucion-licencia-vigente');
    const today = new Date();
    let date = today.getDate() > 9 ? today.getDate() :
      `0${today.getDate()}`;
    let month = today.getMonth() > 9 ? today.getMonth() + 1 :
      `0${today.getMonth() + 1}`;
    let year = today.getFullYear();

    datepicker.setAttribute('max', `${year}-${month}-${date}`);

  }



}
